
import { BillV2, Order } from '@vmos2/kiosk/src/types';
import React, { createContext, Dispatch, SetStateAction, useContext, useState, useEffect, useMemo } from 'react';

export interface BillsV2ContextValue {
  existingBills: BillV2[];
  pendingBill: BillV2 | null;
  setPendingBill: Dispatch<SetStateAction<BillV2 | null>>;
}

interface BillsV2ProviderProps {
  children: React.ReactNode;
  order: Order;
}
export const BillsV2Context = createContext<BillsV2ContextValue | null>(null);
  
export function useBillsV2Context() {
  const context = useContext(BillsV2Context);

  if (context === null) {
    throw new Error('useBillsV2Context must be used within a BillsV2Provider');
  }

  return context;
}


export function BillsV2Provider({ children, order }: BillsV2ProviderProps) {
  const [bills, setBills] = useState<BillV2[]>(readOrderBills(order));
  const [pendingBill, setPendingBill] = useState<BillV2 | null>(null);

  useEffect(() => {
    setBills(readOrderBills(order));
  }, [order]);
  // TODO: we need a way to reset bills when coming back to the order screen
  const value = useMemo(() => {
    return { pendingBill, setPendingBill, existingBills: bills };
  }, [bills, pendingBill]);

  return (
    <BillsV2Context.Provider value={value}>{children}</BillsV2Context.Provider>
  );
}

function readOrderBills(order: Order) {
  return (
    ((order.payment?.transactions || [])
      .map((transaction) => {
        return transaction?.pat?.billV2 || transaction.meta?.pat?.billV2;
      })
      .filter(Boolean) as BillV2[]) || []
  );
}
